// components/ErrorWidget.jsx
import React from 'react';

const ErrorWidget = ({ 
  titulo = "Algo salió mal", 
  mensaje = "No pudimos cargar la información.", 
  accion, // función opcional (ej: recargar página)
  textoAccion = "Reintentar"
}) => {
  return (
    <div className="flex h-screen w-full items-center justify-center bg-gray-100">
      <div className="text-center max-w-md px-6">
        {/* Círculo rojo con ícono de exclamación */}
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-red-100 mb-4">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        </div>

        {/* Título y Mensaje */}
        <h3 className="text-xl font-bold text-gray-900 mb-2">{titulo}</h3>
        <p className="text-lg font-medium text-gray-600 mb-6">{mensaje}</p>
        
        {/* Botón de acción (solo se muestra si pasas la función accion) */}
        {accion && (
          <button 
            onClick={accion}
            className="px-6 py-2 bg-blue-600 text-white font-semibold rounded-lg shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-200"
          >
            {textoAccion}
          </button>
        )}
      </div>
    </div>
  );
};

export default ErrorWidget;